import { BaseWorkspace } from './workspace';

export type WorkspaceVisibility = 'private' | 'team';

export function getWorkspaceVisibilityType(workspace?: BaseWorkspace | null): WorkspaceVisibility {
  if (!workspace) {
    return 'private';
  }

  return workspace.team ? 'team' : 'private';
}
